export { default } from './PlayerAnimat';
